import { render, staticRenderFns } from "./copersatisiade.vue?vue&type=template&id=21cb4c78&"
import script from "./copersatisiade.vue?vue&type=script&lang=js&"
export * from "./copersatisiade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports